import { Roles } from "@/helpers/enums/Roles";
import { store } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";

let title =
  localStorage.getItem("selectedRole") === Roles.AGMSAdmin
    ? "agmsCompanyOverview"
    : "companyOverview";
if (localStorage.getItem("selectedRole") === Roles.PartnerAdmin) {
  title = "partnerOverview";
}
export default [
  {
    path: "company-overview",
    component: () => import("@/views/pages/Dashboard/CompanyOverview.vue"),
    meta: {
      title: title,
    },
    beforeEnter: async (to: any, from: any, next: any) => {
      const role: any = (
        store.state.auth.user.find(f => f.type == "role") || {}
      ).value;
      store.dispatch(GeneralActionTypes.GET_SECTIONS);
      if (role == Roles.AGMSAdmin) {
        next("/administration/manage-partners");
      } else {
        next();
      }
    },
  },
  // {
  //   path: "custom-dashboard",
  //   component: () => import("@/views/pages/Dashboard/CustomDashboardOld.vue"),
  //   meta: {
  //     title: "mainDashboard",
  //   },
  // },
  {
    path: "custom-dashboard",
    component: () => import("@/views/pages/Dashboard/CustomDashboard.vue"),
    meta: {
      title: "customDashboard",
    },
  },
];
